<template>
    <form name="formFiltros" v-on:submit.prevent.stop="buscar" method="get">
        <div class="wrap-filters">
            <div class="row">
                <div class="small-12 medium-10 medium-centered">
                    <ul
                        class="small-block-grid-1 medium-block-grid-3 large-block-grid-4 header-filters"
                        v-if="show_botoes_finalidade"
                    >
                        <li class="header-filter-closed">
                            <label :class="{'active':finalidade=='aluguel'}">
                                <input type="radio" v-model="finalidade" value="aluguel" />
                                <i
                                    :class="{'icon-icon-circle-checked':finalidade=='aluguel', 'icon-icon-circle':finalidade!='aluguel'}"
                                ></i>
                                Quero alugar
                            </label>
                        </li>
                        <li>
                            <label :class="{'active':finalidade=='venda'}" v-on:click="tipo=null">
                                <input type="radio" v-model="finalidade" value="venda" />
                                <i
                                    :class="{'icon-icon-circle-checked':finalidade=='venda', 'icon-icon-circle':finalidade!='venda'}"
                                ></i>
                                Quero comprar
                            </label>
                        </li>
                        <li>
                            <label :class="{'active':finalidade=='condominio'}" v-on:click="tipo=null">
                                <input type="radio" v-model="finalidade" value="condominio" />
                                <i
                                    :class="{'icon-icon-circle-checked':finalidade=='condominio', 'icon-icon-circle':finalidade!='condominio'}"
                                ></i>
                                Condomínio
                            </label>
                        </li>
                    </ul>
                    <div class="search-fields" v-if="['venda', 'aluguel'].includes(finalidade)">
                        <select v-model="modalidade">
                            <option
                                :value="m.id"
                                v-for="m in modalidades"
                                :key="m.id"
                            >{{ m.titulo }}</option>
                        </select>
                        <select v-model="categoria_id" v-if="modalidade!='lancamentos'">
                            <option value>Categoria</option>
                            <option
                                :value="id"
                                v-for="({id, titulo }) in categorias"
                                :key="id"
                            >{{ titulo }}</option>
                        </select>

                        <input
                            type="text"
                            placeholder="Onde fica o imóvel que você deseja?"
                            v-model="search"
                            v-on:keyup.up="suggestionUp"
                            v-on:keyup.down="suggestionDown"
                            v-on:keydown.up="timerUp"
                            v-on:keydown.down="timerDown"
                        />
                        <button
                            class="default-button"
                            type="submit"
                            v-if="imoveis.length == 0 && suggestions.length == 0"
                        >
                            Buscar
                            <i class="fa fa-search" aria-hidden="true"></i>
                        </button>
                        <button
                            class="default-button"
                            type="submit"
                            v-else-if="suggestions.length != 0"
                        >
                            Selecione abaixo
                            <!--<i class="fa fa-search" aria-hidden="true"></i>-->
                        </button>
                        <button class="default-button" type="submit" v-else>
                            Selecione um imóvel abaixo
                            <!--<i class="fa fa-search" aria-hidden="true"></i>-->
                        </button>

                        <div
                            class="suggestions"
                            :class="{'show': suggestions.length!=0}"
                            v-if="suggestions.length != 0 && localidade == null && error == null"
                        >
                            <ul>
                                <li
                                    v-for="(suggestion,index) in suggestions"
                                    v-on:click="setLocation(suggestion)"
                                    :class="{ 'active': index == suggestion_index}"
                                    :key="suggestion.keywords"
                                    v-html="suggestion.texto"
                                ></li>
                            </ul>
                        </div>
                        <div
                            class="suggestions"
                            :class="{'show': error != null || imoveis.length != 0}"
                            v-if="imoveis.length != 0 || error != null"
                        >
                            <ul>
                                <li
                                    v-for="(imovel,index) in imoveis"
                                    :key="imovel.placa"
                                    :class="{ 'active': index == suggestion_index}"
                                >
                                    <a :href="imovel.url" target="_blank">
                                        {{ imovel.placa }} -
                                        {{ imovel.tipo.titulo }}
                                        em
                                        {{ imovel.bairro }},
                                        {{ imovel.cidade }} -
                                        {{ imovel.uf }}
                                    </a>
                                </li>

                                <li v-if="error != null">{{ error }}</li>
                            </ul>
                        </div>
                    </div>
                    <div v-else style="padding: 1em;background-color: rgba(255,255,255,0.5)">
                        <div class="row">
                            
                            <div class="small-12 medium-4 columns">
                                <a href="administracao-de-condominios" class="default-button">Serviços</a>
                            </div>
                            <div class="small-12 medium-4 columns">
                                <a href="https://www.vilarica.com.br/clic-web" class="default-button">Sou Cliente</a>
                            </div>
                            <div class="small-12 medium-4 columns">
                                <a href="administracao-de-condominios/solicite-sua-proposta" class="default-button">Solicite uma Proposta</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-if="['venda', 'aluguel'].includes(finalidade)">
                <div class="small-12 medium-10 medium-centered">
                    <div class="row">
                        <div class="small-12 medium-6 columns">
                            <p class="text-left search-tip">
                                <a
                                    :href="`${finalidade=='aluguel'?'alugar':'comprar'}/${ modalidade }?show_filter=1`"
                                    class="search-tip search-tip-button"
                                >Busca Avançada</a>
                            </p>
                        </div>
                        <div class="small-12 medium-6 columns text-right flex justify-end">
                            <p
                                class="text-right search-tip search-tip-right"
                            >Você pode buscar por cidade, bairro ou código do imóvel.</p>
                        </div>
                    </div>
                </div>
            </div>


            

            <div class="row">
                <div class="small-12 medium-6 medium-centered columns flex justify-around">
                    
                    <a
                        href="https://www.vilarica.com.br/indique-imovel"
                        class="default-button"
                        style="padding: 14px 60px; margin-top: 20vh;"
                        target="_blank"
                    >Indique imóvel</a>
                    
                    <a
                        :href="`${finalidade=='aluguel'?'proprietarios/anuncie-seu-imovel':'comprar/venda-seu-imovel'}`"
                        class="default-button"
                        style="padding: 14px 60px; margin-top: 20vh;"
                        target="_blank"
                    >Anuncie imóvel</a>
                </div>
            </div>
            <div class="show-for-medium-up animated-arrow-container">
                <div class="row">
                    <div
                        class="small-12 columns flex justify-center"
                        style="color: white;margin-top: 5vh;"
                    >Role para ver mais</div>
                </div>
                <div class="row">
                    <div class="small-12 columns flex justify-center">
                        <i class="fa fa-arrow-down animated-arrow" style="color: #e77817;"></i>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>
<style lang="less" scoped>
ul.header-filters {
    li {
        label {
            display: flex;
            justify-content: left;
            align-items: center;
            flex-direction: row;
            padding-left: 1em;
            box-sizing: border-box;
            i {
                font-size: 20px;
                margin-right: 8px;
            }
        }
    }
}

select + select + input[type="text"] {
    width: 60% !important;
}
select + select {
    border-radius: 0 !important;
    border-left: 1px solid #d7d7d7 !important;
}

@media screen and (max-width: 600px) {
    .search-fields {
        select,
        input[type="text"] {
            width: 100% !important;
            margin-bottom: 4px;
        }
    }
    [name="formFiltros"] {
        .medium-centered p {
            text-align: center;
            a {
                display: inline-block;
                padding-top: 16px;
                box-sizing: border-box;
            }
        }
        .justify-around a.default-button {
            margin-top: 0 !important;
        }
    }
}
</style>

<style lang="less">
.animated-arrow-container {
    min-height: 100px;
}
.animated-arrow {
    -webkit-animation: arrowMove 0.5s ease-in-out infinite alternate;
    animation: arrowMove 0.5s ease-in-out infinite alternate;
}
@-webkit-keyframes arrowMove {
    0% {
        margin-top: 0;
    }

    to {
        margin-top: 10px;
    }
}

@keyframes arrowMove {
    0% {
        margin-top: 0;
    }

    to {
        margin-top: 10px;
    }
}

.suggestions {
    .active {
        background: #eee;
    }
}
</style>


<script>
import filtros from "@/store/filtro.js";
import { rest, empresa } from "@/config.js";

import Modalidades from "@/store/modalidades";
import Categorias, { Categorias as AllCategorias } from "@/store/categorias";

import { getTipoById } from "@/api/tipos";
import { getImoveisByCodigo } from "@/api/imoveis";

const FiltroLancamentos = () => import("@/components/FiltroLancamentos.vue");

//let el = document.querySelector('.home [name=formFiltros]');
//let instance = null;
//teste
export default {
    components: {
        FiltroLancamentos
    },
    data() {
        return {
            suggestion_index: null,
            busca: "",
            tipo: null,
            error: null,
            imoveis: [],
            timer: null,
            categoria_id: "",
            Categorias: []
        };
    },
    methods: {
        suggestionUp() {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
        },
        moveUp() {
            let index = this.suggestion_index | 0;
            index--;
            if (index < 0) {
                index = 0;
            }
            this.suggestion_index = index;
            this.$nextTick(() => {
                this.updateSuggestionsScroll();
            });
        },
        suggestionDown() {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
        },
        moveDown() {
            let index = this.suggestion_index;
            if (null == index) {
                index = 0;
            } else {
                index++;
                let max =
                    Math.max(this.suggestions.length, this.imoveis.length) - 1;
                if (index > max) {
                    index = max;
                }
            }
            this.suggestion_index = index;
            this.$nextTick(() => {
                this.updateSuggestionsScroll();
            });
        },
        timerUp() {
            if (this.timer) {
                return;
            }
            this.moveUp();
            this.timer = setTimeout(() => {
                clearTimeout(this.timer);
                this.timer = null;
                this.timerUp();
            }, 150);
        },
        timerDown() {
            if (this.timer) {
                return;
            }
            this.moveDown();
            this.timer = setTimeout(() => {
                clearTimeout(this.timer);
                this.timer = null;
                this.timerDown();
            }, 150);
        },
        updateSuggestionsScroll() {
            const $suggestions = this.$el.querySelector(".suggestions");
            if (!$suggestions) {
                return;
            }
            const $active = $suggestions.querySelector(".active");
            const scrollHeight = $suggestions.scrollHeight;
            const scrollTop = $suggestions.scrollTop;

            const height = $suggestions.clientHeight;
            const top = $active.offsetTop - scrollTop;
            const bottom = top + $active.offsetHeight;

            if (bottom > height) {
                $suggestions.scrollTop += bottom - height;
            }

            if (0 > top) {
                $suggestions.scrollTop += top;
            }
        },
        setLocation(suggestion) {
            this.busca = suggestion.text;
            this.$store.dispatch("setLocation", suggestion.value);
            this.$store.dispatch("setTiposIds", suggestion.tipos);
            this.buscar();
        },
        verifySuggestions() {
            this.$nextTick(() => {
                let suggestions = this.$store.state.suggestions[
                    this.finalidade
                ][this.modalidade].map(({ value }) => value);
                if (-1 == suggestions.indexOf(this.localidade)) {
                    this.localidade = null;

                    this.busca = "";
                }
            });
        },
        async buscar() {
            let finalidade = this.finalidade;
            let modalidade = this.modalidade;

            if (this.suggestion_index != null) {
                if (this.suggestions.length != 0) {
                    let suggestion = this.suggestions[this.suggestion_index];
                    this.suggestion_index = null;
                    this.setLocation(suggestion);
                    return;
                }
                if (this.imoveis.length != 0) {
                    let imovel = this.imoveis[this.suggestion_index];
                    window.open(imovel.url);
                    return;
                }
            }

            if (this.localidade) {
                let url =
                    document.baseURI +
                    `${
                        finalidade == "aluguel" ? "alugar" : "comprar"
                    }/${modalidade}/${this.localidade}`;
                //window.open(url);

                if (0 != this.tiposIds.length) {
                    url += "?tipo_id=" + this.tiposIds.join(",");
                } else if ("" != this.categoria_id) {
                    url += "?tipo_id=" + this.categoria_id;
                }

                location.href = url;
                return;
            }

            if (this.busca == "") {
                let localidade_id = 'porto-alegre-rs';
                let cidade = filtros.state.cidades[finalidade].find(({id}) => id == localidade_id);
                if (!cidade) {
                    let [c] = filtros.state.cidades[finalidade];

                    localidade_id = c.id;
                }
                let url = `${
                    finalidade == "aluguel" ? "alugar" : "comprar"
                }/${modalidade}/${localidade_id}`;

                
                

                if (0 != this.tiposIds.length) {
                    url += "?tipo_id=" + this.tiposIds.join(",");
                } else if ("" != this.categoria_id) {
                    url += "?tipo_id=" + this.categoria_id;
                }

                location.href = url;
                return;
            }
            let win = window.open("about:blank", "_blank");
            let codigo = this.busca.toUpperCase();
            let codigo_numerico = this.busca.replace(/\D/gim, "");

            let resp = await getImoveisByCodigo(codigo_numerico);
            let imoveis = resp
                .filter(imovel => imovel != null)
                .filter(imovel => {
                    if (imovel.finalidade == "venda") {
                        return true;
                    }
                    if (empresa.slug == "vila-rica") {
                        return !/^saoluiz/gim.test(imovel.placa);
                    } else {
                        return /^saoluiz/gim.test(imovel.placa);
                    }
                });

            if (imoveis.length == 0) {
                this.error = "Nenhum imóvel encontrado";
                win.close();
                return;
            }
            if (imoveis.length == 1) {
                let [imovel] = imoveis;
                //window.open(imovel.url);
                win.location.href = imovel.url;

                //return;
                //location.href = imovel.url;
            } else {
                this.imoveis = imoveis;
                win.close();
            }
        }
    },
    computed: {
        show_botoes_finalidade() {
            return !/(alugar|comprar)$/igm.test(location.pathname);
        },
        search: {
            get() {
                return this.busca || "";
            },
            set(value) {
                this.busca = value;
                this.error = null;
                this.imoveis = [];
                this.$store.dispatch("setLocation", null);
                this.$store.dispatch("setTiposIds", []);
                this.suggestion_index = null;
            }
        },
        modalidades() {
            return Modalidades[this.finalidade];
        },
        finalidade: {
            get() {
                return this.$store.state.finalidade;
            },
            set(value) {
                this.$store.state.finalidade = value;
                if (value == "venda") {
                    this.$store.state.modalidade = "prontos";
                } else {
                    this.$store.state.modalidade = "residencial";
                }
                this.tipo = null;
                this.verifySuggestions();

                document.body.classList.remove('finalidade-aluguel','finalidade-venda','finalidade-condominio');
                document.body.classList.add(`finalidade-${value}`);
                window.setTimeout(() => {
                    let index = $(`.slideshow-${this.finalidade} .card-banner`).slick('slickCurrentSlide');
                    $(`.slideshow-${this.finalidade} .card-banner`).slick('slickSetOption', 'autoplay', true, true);
                    
                }, 0);
            }
        },
        localidade: {
            get() {
                return this.$store.state.localidade;
            },
            set(value) {
                this.$store.state.localidade = value;
            }
        },
        tiposIds() {
            return this.$store.state.tipos_ids || [];
        },
        modalidade: {
            get() {
                return this.$store.state.modalidade;
            },
            set(value) {
                this.$store.state.modalidade = value;

                this.verifySuggestions();
            }
        },
        categorias() {
            let tipos = this.$store.state.tipos[this.finalidade][
                this.modalidade
            ];
            tipos = [...tipos];
            tipos.sort((a, b) => {
                return a.titulo < b.titulo ? -1 : 1;
            });

            if (this.finalidade == "aluguel" || true) {
                let ids = tipos.map(({ id }) => `${id}`);
                const categorias = this.Categorias.filter(
                    ({ ids: IDS, titulo, modalidade }) => {
                        if (modalidade != this.modalidade) {
                            return false;
                        }
                        if (
                            ids.filter(value => IDS.includes(value)).length ===
                            0
                        ) {
                            return false;
                        }

                        return true;
                    }
                ).map(categoria => ({
                    id: categoria.ids.join(","),
                    ...categoria
                }));
                tipos = categorias;
            }

            let ids = tipos.map(({ id }) => id);
            if (-1 == ids.indexOf(this.categoria_id)) {
                this.categoria_id = "";
            }

            return tipos;
        },
        categoria() {
            let categoria_id = this.categoria_id || "";
            if (categoria_id == "") return null;
            let categorias = this.categorias;
            if (0 == categorias.length) return null;
            return categorias.find(({ id }) => id == categoria_id);
        },
        suggestions() {
            let search = this.search;
            if (search == "") {
                return [];
            }
            let keywords = search
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
                .replace(/[^\w\d]/gim, " ")
                .split(/\s+/gim);
            let suggestions = this.$store.state.suggestions[this.finalidade][
                this.modalidade
            ];
            let tipos = this.$store.state.tipos[this.finalidade][
                this.modalidade
            ]
                .filter(tipo => {
                    return /casa|apartamento/gim.test(tipo.slug);
                })
                .reduce(
                    (acc, tipo) => {
                        if (/casa/gim.test(tipo.slug)) {
                            acc.casa.ids.push(tipo.id);
                        } else if (/apartamento/gim.test(tipo.slug)) {
                            acc.apartamento.ids.push(tipo.id);
                        }
                        return acc;
                    },
                    {
                        casa: {
                            slug: "casas",
                            titulo: "Casas",
                            ids: []
                        },
                        apartamento: {
                            slug: "apartamentos",
                            titulo: "Apartamentos",
                            ids: []
                        }
                    }
                );
            //remoção dos tipos nas sugestões;
            tipos = [];
            //fim remoção dos tipos
            tipos = Object.keys(tipos)
                .map(slug => {
                    return tipos[slug];
                })
                .filter(tipo => {
                    if (0 == tipo.ids.length) {
                        return false;
                    }
                    let regexp = new RegExp(keywords.join("|"), "igm");
                    return regexp.test(tipo.slug);
                });

            let rows = suggestions.map(({ text, value }) => {
                let keywords = value;
                return { text, value, keywords, tipos: [] };
            });
            tipos.forEach(tipo => {
                suggestions.forEach(({ text: texto, value }) => {
                    let text = `${tipo.titulo} em ${texto}`;
                    let keywords = `${tipo.slug}-em-${value}`;
                    rows.push({ text, value, keywords, tipos: tipo.ids });
                });
            });

            rows = rows
                .filter(suggestion => {
                    return keywords.reduce((acc, keyword) => {
                        if (acc) {
                            let regex = new RegExp(keyword, "igm");
                            acc = regex.test(suggestion.keywords);
                        }
                        return acc;
                    }, true);
                })
                .map(({ text, value, tipos }) => {
                    let texto = text
                        .split(/\s+/gim)
                        .map(t => {
                            let regex = new RegExp(
                                "(" +
                                    keywords
                                        .join("|")
                                        .replace(/a/gim, "[aãáàäâ]")
                                        .replace(/e/gim, "[eĩéèëê]")
                                        .replace(/i/gim, "[iĩíìïî]")
                                        .replace(/o/gim, "[oõíìïî]")
                                        .replace(/u/gim, "[uũúùüû]")
                                        .replace(/c/gim, "[cçĉ]")
                                        .replace(/n/gim, "[nñńǹ]") +
                                    ")",
                                "igm"
                            );

                            return t.replace(
                                regex,
                                '<span class="highlight">$1</span>'
                            );
                        })
                        .join(" ");
                    return {
                        text,
                        texto,
                        value,
                        tipos
                    };
                });
            rows.sort((a, b) => {
                if (/\,/gim.test(a.text) && !/\,/gim.test(b.text)) {
                    return 1;
                } else if (!/\,/gim.test(a.text) && /\,/gim.test(b.text)) {
                    return -1;
                }
                return a.value < b.value ? -1 : 1;
            });
            return rows;
        }
    },
    store: filtros,
    async created() {
        document.body.classList.remove('finalidade-aluguel','finalidade-venda','finalidade-condominio');
        document.body.classList.add(`finalidade-${this.finalidade}`);

        window.setTimeout(() => {
            let index = $(`.slideshow-${this.finalidade} .card-banner`).slick('slickCurrentSlide');
            $(`.slideshow-${this.finalidade} .card-banner`).slick('slickSetOption', 'autoplay', true, true);
            
        }, 0);

        this.Categorias = await AllCategorias;
    
    }
};
</script>
